import { render, staticRenderFns } from "./loginuser.vue?vue&type=template&id=12f2ce73&"
import script from "./loginuser.vue?vue&type=script&lang=js&"
export * from "./loginuser.vue?vue&type=script&lang=js&"
import style0 from "./loginuser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports